import type {JSX} from 'react';
import {ShieldCheck} from 'lucide-react';
import {useGmailConnection} from '../hooks/useGmailConnection';
import {useGmailOutcome} from '../hooks/useGmailOutcome';
import {ConnectionPanel} from '../components/connections/ConnectionPanel';
import {GmailSetup} from '../components/connections/GmailSetup';
import {DisconnectDialog} from '../components/connections/DisconnectDialog';

export default function ConnectionsPage(): JSX.Element {
  const connection = useGmailConnection();
  useGmailOutcome();
  return <div className="content-page page-enter">
    <div className="page-intro"><div><h1 data-testid="connections-heading">Connections</h1><p data-testid="connections-subtitle">Bring the conversation into one place.</p></div></div>
    <div className="connection-layout">
      <ConnectionPanel connection={connection}/><GmailSetup gmail={connection.gmail}/>
      <div className="settings-row"><div><h3>Your inbox stays yours</h3><p data-testid="gmail-privacy-note">Connection tokens are encrypted. Imported message identifiers are masked before storage. Disconnecting stops future syncs; existing tickets remain until you delete them.</p></div><ShieldCheck size={22} color="#71d6b0"/></div>
    </div>
    <DisconnectDialog connection={connection}/>
  </div>;
}